import { FeatureFlags } from '#lib/constants/feature-flags.js';
import { seriesPageLoad } from '#lib/websites/editions/pages/SeriesPage/utils/seriesPageLoad/seriesPageLoad.js';
import { seriesPageLoadGql } from '#lib/websites/editions/pages/SeriesPage/utils/seriesPageLoadGql/seriesPageLoadGql.js';

export const load = FeatureFlags.RestPages['/editions/series/[slug]']
	? seriesPageLoad
	: seriesPageLoadGql;
